import './DoVerification.css'

import { useScript } from '../../utils/useScript'

const FLOW_SCRIPT_URL = 'https://cdn.cognitohq.com/flow.js'
export const useCognitoFlowScript = (shouldLoad = false) => {
    return useScript(shouldLoad ? FLOW_SCRIPT_URL : '')
}
